<div class="korespondencja-dialog">
  <div class="table-container">
    @if (loading()) {
      <p-progressSpinner class="loading-spinner" />
    }

    @if (error() && !loading()) {
      <div class="text-center text-red-500 mt-3">{{ error() }}</div>
    }

    @if (!loading() && !error() && !typyWnioskow().length) {
      <div class="no-results">
        Nie udało się pobrać typów dokumentów lub brak dostępnych pozycji.
      </div>
    }

    @if (!loading() && !error() && typyWnioskow().length > 0) {
      <p-table
        [value]="typyWnioskow()"
        selectionMode="single"
        [selection]="selectedTyp()"
        (selectionChange)="selectedTyp.set($event)"
        dataKey="kod"
        [paginator]="true"
        paginatorDropdownAppendTo="body"
        [rows]="5"
        [rowsPerPageOptions]="[5, 10, 25]"
      >
        <ng-template pTemplate="header">
          <tr>
            <td></td>
            <th>Nazwa wniosku</th>
            <th>Instrukcja wypełniania wniosku</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-typ>
          <tr [pSelectableRow]="typ">
            <td>
              <p-radioButton
                [tabindex]="-1"
                [inputId]="typ.kod"
                name="typWniosku"
                ariaLabel="Wybór wiersza"
                [value]="typ"
                [ngModel]="selectedTyp()"
                (ngModelChange)="selectedTyp.set($event)"
              />
            </td>
            <td>{{ typ.nazwa }}</td>
            <td style="text-align: center">
              <a
                class="instruction-label"
                tabindex="0"
                href="/api/instructions/instrukcja_rejestracji_wniosku_zs.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  style="padding: 0.5rem"
                  class="pi pi-download icon"
                  aria-hidden="true"
                ></i>
              </a>
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </div>

  <div class="actions">
    <p-button
      label="Utwórz wniosek"
      styleClass="customInfoButton outlined"
      icon="pi pi-check"
      [disabled]="!selectedTyp()"
      (onClick)="createApplication()"
    />
    <p-button
      label="Anuluj"
      icon="pi pi-times"
      severity="secondary"
      (onClick)="cancel()"
    />
  </div>
</div>
